import styled from 'styled-components';

import Map from './Map';

const StyledMap = styled(Map)`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;

    .modal__close {
        position: relative;
        font-size: 2rem;
        line-height: 2rem;
        position: absolute;
        right: 2rem;
        top: 2rem;
        height: 5rem;
        padding: 1rem 1.9rem;
        width: 5rem;
        z-index: 1;

        &:before,
        &:after {
            content: '';
            position: absolute;
            top: 2.3ßrem;
            display: block;
            width: 2rem;
            height: 0.28rem;
            background-color: ${(props) => props.theme.colours.white};
            transition: background-color linear 0.2s;
        }

        &:before {
            left: 1.5rem;
            transform: rotate(45deg);
        }

        &:after {
            right: 1.5rem;
            transform: rotate(135deg);
        }

        &::-moz-focus-inner {
            border: 0;
        }
    }
`;

export default StyledMap;
